import { ElementRef, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { DragDropDirective } from 'Angular/features/directives/drag-drop/drag-drop.directive';
import { FolderableBulkMoveStrategy } from './folderable-bulk-move-strategy';
import { FolderableIndividualMoveStrategy } from './folderable-individual-move-strategy';
import * as i0 from "@angular/core";
/**
 * Directive for an item in the folder item list.
 * Elements that use this directive can represent a file or a folder.
 * Used to display and manage drag-drop operations related to the item.
 */
export class FolderableDirective extends DragDropDirective {
    constructor() {
        super(...arguments);
        this.BULK_MOVE_STRATEGY = FolderableBulkMoveStrategy;
        this.INDIVIDUAL_MOVE_STRATEGY = FolderableIndividualMoveStrategy;
        this.bulkActionSelectionService = inject(BulkActionSelectionService);
        this.elemRef = inject(ElementRef);
        this.folderOperationsService = inject(FolderOperationsService);
        this.folderableCollectionService = inject(FolderableCollectionServiceBase);
        this.toastMessagesService = inject(PageToastMessagesService);
    }
    get itemId() {
        if (this.folderable.resourceType === FolderableType.MY_YCHARTS) {
            return this.folderable.item.item_id;
        }
        return this.folderable.item.id;
    }
    get resourceType() {
        if (this.folderable.resourceType === FolderableType.MY_YCHARTS) {
            return this.folderable.item.resource_type;
        }
        return this.folderable.resourceType;
    }
    get isValidDropTarget() {
        return this.moveStrategy.isValidDropTarget;
    }
    ngOnInit() {
        super.ngOnInit();
        this.bulkActionSelectionService.bulkActionMode$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((bulkActionMode) => {
            if (this.moveStrategy) {
                // @ts-ignore
                delete this.moveStrategy;
            }
            this.moveStrategy = bulkActionMode
                ? new this.BULK_MOVE_STRATEGY(this)
                : new this.INDIVIDUAL_MOVE_STRATEGY(this);
        });
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    setEventData(event) {
        this.moveStrategy.setEventData(event);
    }
    dropEventHandler(event) {
        this.moveStrategy.dropEventHandler(event);
    }
    drop(event) {
        this.moveStrategy.drop(event, super.drop.bind(this));
    }
    dragenter(event) {
        this.moveStrategy.dragenter(event, super.dragenter.bind(this));
    }
    dragover(event) {
        this.moveStrategy.dragover(event, super.dragover.bind(this));
    }
    dragend(event) {
        this.moveStrategy.dragend(event, super.dragend.bind(this));
    }
    dragleave(event) {
        this.moveStrategy.dragleave(event, super.dragleave.bind(this));
    }
}
FolderableDirective.ɵfac = /*@__PURE__*/ (() => { let ɵFolderableDirective_BaseFactory; return function FolderableDirective_Factory(__ngFactoryType__) { return (ɵFolderableDirective_BaseFactory || (ɵFolderableDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FolderableDirective)))(__ngFactoryType__ || FolderableDirective); }; })();
FolderableDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableDirective, selectors: [["", "ycn-folderable", ""]], inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature] });
